// responsiveClsx.ts
import clsx from 'clsx';

// Define your breakpoints with TypeScript types
type Breakpoints = {
  mobile: '(min-width: 320px)';
  tablet: '(min-width: 640px)';
  laptop: '(min-width: 1024px)';
  desktop: '(min-width: 1280px)';
};

const breakpoints: Breakpoints = {
  mobile: '(min-width: 320px)',
  tablet: '(min-width: 640px)',
  laptop: '(min-width: 1024px)',
  desktop: '(min-width: 1280px)',
};

// Parse the responsive class names
export const responsiveClsx = (classes: string): string => {
  const classMap: Record<string, string> = {};
  const classList = classes.split(' ');

  classList.forEach((classItem) => {
    const [key, ...classNames] = classItem.split(':');
    if (breakpoints[key as keyof Breakpoints]) {
      classMap[breakpoints[key as keyof Breakpoints]] = classNames.join(':');
    }
  });

  return clsx(Object.keys(classMap).map((mediaQuery) => `@media ${mediaQuery} { ${classMap[mediaQuery]} }`));
};


export const detectMob =() => {
  const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      
      /BlackBerry/i,
      /Windows Phone/i
  ];
  
  return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
  });
}